export const pageTitle = (title) => {
  return (document.title = title + " - Cryptovision  web3 End-to-end Blockchain Service and development");
}